export default __webpack_public_path__ + "5deeabc51ef3ee53195edb38a3612468.png";